/**
 * Enterprises Feature Routes
 */
import type { RouteRecordRaw } from 'vue-router';

export const enterprisesRoutes: RouteRecordRaw[] = [
  {
    path: '/enterprises',
    name: 'enterprises',
    component: () => import('./views/EnterpriseListView.vue'),
    meta: {
      title: 'Enterprise Management',
      breadcrumbs: [{ label: 'Enterprise Management' }],
      modulePermission: 'enterprisesManagement',
    },
  },
];
